import { Card, CardHeader } from 'components/elements';
import { ScrollArea } from 'components/elements/ScrollArea';
import { styled } from 'styles';

export const DialogCard = styled(Card)`
  box-shadow: ${({ theme }) => theme.spacing.absolute.huge};
  max-width: 60em;
`;

export const DialogCardHeader = styled(CardHeader)`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.absolute.small}
    ${({ theme }) => theme.spacing.absolute.small} ${({ theme }) => theme.spacing.absolute.small}
    ${({ theme }) => theme.spacing.absolute.larger};
`;

export const DialogScrollArea = styled(ScrollArea)`
  max-height: 75vh;
`;

export const StyledDialog = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing.absolute.huge};
  position: absolute;
  top: 0;
  transition: opacity ${({ theme }) => theme.transition.fast} ease-in-out;
  width: 100%;
  z-index: 10;

  &.enter {
    opacity: 0;
  }

  &.enter-active,
  &.enter-done {
    opacity: 1;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }
`;

DialogCard.displayName = 'DialogCard';
DialogCardHeader.displayName = 'DialogCardHeader';
DialogScrollArea.displayName = 'DialogScrollArea';
StyledDialog.displayName = 'Dialog.Styled';
